var map = {
	"./Hajj_cards_banner.jpeg": 4386,
	"./card1.png": 3916,
	"./card2.png": 2647,
	"./card3.png": 2654,
	"./contact-us.jpg": 7918,
	"./desert.mp4": 6043,
	"./holy1.jpg": 1832,
	"./khaba.mp4": 4995,
	"./logo1.png": 1234,
	"./logo2.png": 1022,
	"./mosque.mp4": 8650,
	"./sheikh_zayad_mosque.mp4": 3379,
	"./tent.jpg": 8564
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1803;